import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { LoggerService } from 'core/logger/logger.service';
import * as pbi from 'powerbi-client';
import { environment } from 'src/environments/environment';
import { PowerBiService } from './power-bi.service';

@Component({
  selector: 'app-power-bi-report',
  templateUrl: './power-bi-report.component.html',
  styleUrl: './power-bi-report.component.scss',
  standalone: false
})
export class PowerBiReportComponent implements OnInit, OnDestroy {
  @ViewChild('reportContainer', { static: true }) reportContainer: ElementRef<HTMLDivElement>;

  isLoading = true;
  errorMessage: string | null = null;

  private powerbi: pbi.service.Service;

  constructor(
    private powerBiService: PowerBiService,
    private appInfoService: AppInfoService,
    private logger: LoggerService,
  ) {
    this.powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
  }

  ngOnInit() {
    const user = this.appInfoService.userData?.UserInfo;
    const isAdmin = this.appInfoService.isAdminTypeUser();

    this.powerBiService.getEmbedConfig().subscribe({
      next: (config) => {
        this.isLoading = false;
        this.logger.logInfo(
          `[PowerBI] Embedding report ${config.reportId} for user: ${user?.Name} (UserId=${user?.UserId})`
        );
        this.embedReport(config.embedUrl, config.embedToken, config.reportId, isAdmin ? null : user?.UserId ?? null, isAdmin);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = 'Failed to load report. Please try again later.';
        this.logger.logError(`[PowerBI] Failed to fetch embed config: ${err?.message ?? err}`);
        console.error('[PowerBI] Embed config error:', err);
      }
    });
  }

  ngOnDestroy() {
    if (this.reportContainer?.nativeElement) {
      this.powerbi.reset(this.reportContainer.nativeElement);
    }
  }

  private embedReport(embedUrl: string, accessToken: string, reportId: string, userId: string | null, isAdmin: boolean) {
    const filters: pbi.models.IBasicFilter[] = userId ? [
      {
        $schema: 'https://powerbi.com/product/schema#basic',
        target: { table: 'Profile', column: 'IMP 1 UID' },
        operator: 'In',
        values: [userId],
        filterType: pbi.models.FilterType.Basic
      }
    ] : [];

    const pageName = isAdmin ? environment.powerBiPageNames.admin : environment.powerBiPageNames.accountManager;

    const config: pbi.IEmbedConfiguration = {
      type: 'report',
      tokenType: pbi.models.TokenType.Embed,
      accessToken,
      embedUrl,
      id: reportId,
      filters,
      pageName,
      settings: {
        panes: {
          filters: { visible: false },
          pageNavigation: { visible: false }
        }
      }
    };

    this.powerbi.embed(this.reportContainer.nativeElement, config);
  }
}
